module.exports = __webpack_public_path__ + "img/myprofile-cancelbtn.e58da77b.svg";